"use client";

import { usePathname } from "next/navigation";
import { useEffect, useRef, useState } from "react";

import { isChatPath, isSettingsPath } from "@/config/navigation";

const DEFAULT_APP_LOCATION = "/";

function isShellSecondaryPath(pathname: string): boolean {
  return isSettingsPath(pathname) || isChatPath(pathname);
}

/** Last pathname visited outside settings/chat shells, for Back to app. */
export function useLastAppLocation() {
  const pathname = usePathname() ?? "/";
  const [lastAppLocation, setLastAppLocation] = useState(DEFAULT_APP_LOCATION);
  const previousPathRef = useRef(pathname);

  useEffect(() => {
    const previous = previousPathRef.current;
    if (!isShellSecondaryPath(previous) && previous !== pathname) {
      setLastAppLocation(previous);
    }
    previousPathRef.current = pathname;
  }, [pathname]);

  return lastAppLocation;
}
